import { PULL_AREA_ATTRIBUTE } from 'common/hooks/pull-to-refresh/pull-to-refresh.constants';
import { LoadableComponent } from 'common/components/loadable';
import { PropsWithChildren, ReactNode } from 'react';
import { WorkflowErrorComponent } from '../error';
import {
  WorkflowContentBody,
  WorkflowContentFooter,
  WorkflowContentInnerLayout,
  WorkflowContentLayout,
} from './workflow-content.style';

interface WorkflowContentComponentProps extends PropsWithChildren {
  isLoading?: boolean;
  isError?: boolean;
  onRetry?: VoidFunction;
  onGoHome?: VoidFunction;
  footer?: ReactNode;
}

export const WorkflowContentComponent: React.FC<WorkflowContentComponentProps> = props => {
  const { isLoading = false, isError = false, onRetry, onGoHome, footer, children } = props;

  const showError = isError && !isLoading;

  return (
    <WorkflowContentLayout slot="content" {...{ [PULL_AREA_ATTRIBUTE]: '' }}>
      <WorkflowContentInnerLayout>
        {showError ? (
          <WorkflowErrorComponent onRetry={onRetry} onGoHome={onGoHome} />
        ) : (
          <>
            <WorkflowContentBody>
              <LoadableComponent isLoading={isLoading}>{children}</LoadableComponent>
            </WorkflowContentBody>
            {footer && (
              <WorkflowContentFooter data-testid="workflow-footer">{footer}</WorkflowContentFooter>
            )}
          </>
        )}
      </WorkflowContentInnerLayout>
    </WorkflowContentLayout>
  );
};
